// extracted by mini-css-extract-plugin
export var attachmentContainer = "_lu-0";
export var fileList = "_lu-2";
export var removeFileButton = "_lu-1";